import React, { useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import './App.scss';
import HeaderNav from 'components/HeaderNav';
import Footer from 'components/Footer';
import SideNav from 'components/SideNav';
import Banner from 'components/Banner';
import TechStack from 'components/TechStack/index';
import IsotopeCards from 'components/IsotopCards';

function App() {
  let [isNavExpanded, setIsNavExpanded] = useState(false);

  function handleNavClick() {
    setIsNavExpanded(!isNavExpanded);
  }

  return (
    <Router>
      <div className={'App  ' + (isNavExpanded ? 'nav-expanded' : '')}>
        <HeaderNav onClick={handleNavClick} />
        <SideNav onClick={handleNavClick} />
        <Banner />
        <TechStack />
        <IsotopeCards />
        <Footer />
      </div>
    </Router>
  );
}

export default App;
